module.exports = __webpack_public_path__ + "static/media/redTriangle.baeb251a.svg";